<template>
  <iColumn gap="large">
    <iColumn v-if="showCollaboratorName" gap="small">
      <iText>
        Collaborator Name
      </iText>
      <iText font-size="large">
        {{ formData.inviteeName }}
      </iText>
    </iColumn>

    <iColumn gap="small">
      <iTextArea
        :model-value="formData.scopeOfWork"
        placeholder="Describe what this collaborator will be required to do"
        :rows="5"
        width="fill"
        label="Scope of Work"
        @update:model-value="updateScopeOfWork($event)"
      />
      <iText v-if="validationErrors.scopeOfWork" variant="error">
        {{ validationErrors.scopeOfWork }}
      </iText>
    </iColumn>

    <!-- Compensation section intentionally hidden -->
    <!--
    <iColumn gap="large" :width="390">
      <iSubHeading>Compensation</iSubHeading>
      <iText v-if="validationErrors.paymentType" variant="error">
        {{ validationErrors.paymentType }}
      </iText>

      <iRow vertical-align="middle" align="left" wrap="nowrap">
        <iCheckbox
          :model-value="formData.noCompensation"
          width="hug"
          @update:model-value="updateNoCompensation($event)"
        />
        <iText :wrap="false">
          No Compensation
        </iText>
      </iRow>

      <iRow
        vertical-align="middle"
        align="left"
        wrap="nowrap"
        :disabled="formData.noCompensation"
      >
        <iCheckbox
          :model-value="formData.flatFee"
          width="hug"
          @update:model-value="updateFlatFee($event)"
        />
        <iText :wrap="false">
          Flat fee
        </iText>
        <iTextInput
          size="small"
          :model-value="formData.flatFeeAmount"
          placeholder="Specify a Dollar Amount"
          type="number"
          width="fill"
          @update:model-value="updateFlatFeeAmount($event)"
        />
      </iRow>
      <iText v-if="validationErrors.flatFeeDetails" variant="error">
        {{ validationErrors.flatFeeDetails }}
      </iText>

      <iRow
        vertical-align="middle"
        align="left"
        wrap="nowrap"
        :disabled="formData.noCompensation"
      >
        <iCheckbox
          :model-value="formData.percentRevenue"
          width="hug"
          @update:model-value="updatePercentRevenue($event)"
        />
        <iText :wrap="false">
          Percentage of Revenue
        </iText>
        <iTextInput
          :model-value="formData.percentRevenueValue"
          placeholder="Specify a Percentage"
          type="number"
          size="small"
          width="fill"
          @update:model-value="updatePercentRevenueValue($event)"
        />
      </iRow>
      <iText v-if="validationErrors.percentRevenueValue" variant="error">
        {{ validationErrors.percentRevenueValue }}
      </iText>

      <iRow
        vertical-align="middle"
        align="left"
        wrap="nowrap"
        :disabled="formData.noCompensation"
      >
        <iCheckbox
          :model-value="formData.performanceBonus"
          label="Automatic - Performance Based Revenue Sharing"
          width="hug"
          @update:model-value="updatePerformanceBonus($event)"
        />
      </iRow>
      <iText v-if="validationErrors.performanceBonusDetails" variant="error">
        {{ validationErrors.performanceBonusDetails }}
      </iText>
    </iColumn>
    -->
    <iSpace />
    <iRow
      vertical-align="middle"
      align="right"
      width="fill"
    >
      <iButton
        v-if="showSendContractButton"
        :disabled="isLoading"
        @click="sendInvite"
      >
        Send Invite
      </iButton>
    </iRow>
  </iColumn>
</template>

<script>
import { createFormMethods } from "@/helpers/form-helpers";

export default {
  name: "ContractProposalForm",
  props: {
    formData: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
    },
    showCollaboratorName: {
      type: Boolean,
      required: false,
      default: true,
    },
    showSendContractButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["update:formData", "update:validationErrors", "send-invite"],
  created() {
    if (this.formData.noCompensation !== true) {
      this.emitFormData({
        noCompensation: true,
        flatFee: false,
        flatFeeAmount: "",
        flatFeeFrequency: null,
        percentRevenue: false,
        percentRevenueValue: "",
        performanceBonus: false,
        performanceBonusAmount: "",
        performanceBonusFrequency: null,
      });
    }
  },
  methods: {
    ...createFormMethods([
      "scopeOfWork",
      // "flatFeeAmount",
      // "flatFeeFrequency",
      // "percentRevenueValue",
      // "performanceBonusAmount",
      // "performanceBonusFrequency",
    ]),
    emitFormData(data) {
      this.$emit("update:formData", {
        ...this.formData,
        ...data,
      });
    },
    // updateNoCompensation(value) {
    //   if (value) {
    //     this.emitFormData({
    //       noCompensation: true,
    //       flatFee: false,
    //       percentRevenue: false,
    //       performanceBonus: false,
    //     });
    //     return;
    //   }
    //
    //   this.emitFormData({
    //     noCompensation: false,
    //   });
    // },
    // updateFlatFee(value) {
    //   this.emitFormData({
    //     flatFee: value,
    //     noCompensation: value ? false : this.formData.noCompensation,
    //   });
    // },
    // updatePercentRevenue(value) {
    //   this.emitFormData({
    //     percentRevenue: value,
    //     noCompensation: value ? false : this.formData.noCompensation,
    //   });
    // },
    // updatePerformanceBonus(value) {
    //   this.emitFormData({
    //     performanceBonus: value,
    //     noCompensation: value ? false : this.formData.noCompensation,
    //   });
    // },
    sendInvite() {
      this.$emit("send-invite");
    },
  },
};
</script>

<style scoped lang="scss">

:deep(.i-text) {
  overflow: visible;
}

</style>
